/**
 * 配置编译环境和线上环境之间的切换
 *
 * baseUrl: 域名地址
 * baseImgPath: 图片存放地址
 *
 */
let baseUrl = '';
let baseImgPath;

if (process.env.NODE_ENV == 'development') {
	//开发环境
	baseUrl = 'http://wct.kdjy.net.cn/';
	//baseUrl = 'http://localhost:62892/';
	//baseUrl = 'http://49.4.53.104:200/';
	
} else {
	baseUrl = 'http://wct.kdjy.net.cn/';
	//baseUrl = 'http://localhost:62892/';
	//baseUrl = 'http://43.254.1.164:6009/';
}

export {
	baseUrl,baseImgPath
}
